import React, { Dispatch, SetStateAction } from "react";
import { Box, IconButton, Menu, MenuItem, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { SubadminTypes } from "../../types/General";
import { UPDATE_TYPES } from "../../utils/enums";

type props = {
  rows: SubadminTypes[];
  loading: boolean;
  count: number;
  page: number;
  handlePageChange: (event: any, newPage: number) => void;
  setSelectedId: Dispatch<SetStateAction<number | null>>;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setOpenWarnModal: Dispatch<SetStateAction<boolean>>;
  handleUserUpdate: (id: number, status: any, type: string) => void;
  setFlag: Dispatch<SetStateAction<boolean>>;
};

const UserListTable = ({
  rows,
  loading,
  count,
  page,
  handlePageChange,
  setSelectedId,
  setOpen,
  setOpenWarnModal,
  handleUserUpdate,
  setFlag,
}: props) => {
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 300,
      field: "user",
      headerName: "User",
      editable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img
                src={
                  row?.profile_picture?.media_url ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>
                {row?.first_name} {row?.middle_name || ""}{" "}
                {row?.last_name || ""}
              </b>{" "}
              {row?.country_code} {row?.phone_no || "-"} <br />
              {row?.email || "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "sub_role",
      headerName: "Role",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 200,
      field: "status",
      filterable: false,
      sortable: false,
      headerName: "Status",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.is_active}
            onChange={() =>
              handleUserUpdate(row?.id, !row?.is_active, UPDATE_TYPES.BLOCK)
            }
          />
        );
      },
    },
    {
      flex: 0.5,
      minWidth: 140,
      field: "action",
      headerName: "action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row?.id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {/* <MenuItem
                  onClick={() =>
                    navigate(`/profile-detail/individual/${selectedId}`)
                  }
                >
                  View
                </MenuItem> */}
                <MenuItem
                  onClick={() => {
                    setFlag(true);
                    setOpen(true);
                    setAnchorEl1(null);
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setFlag(false);
                    setAnchorEl1(null);
                    setOpenWarnModal(true);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default UserListTable;
